


























import { computed, defineComponent, reactive } from '@vue/composition-api';
import { useQuery } from '@vue/apollo-composable';

import hubPriceIndex from '@/gql/managementReport/03-Profit/3.2-DeliveryPerPrice/hubPriceIndex.gql';

import CommonHubSelector from '@/components/CommonHubSelector.vue';
import PerPriceHorizontalBarChart from '@/components/Vivat/Chart/PerPriceHorizontalBarChart.vue';

import {
  NOW_START_MONTH,
  NOW_END_MONTH,
} from '@/utils';

interface PriceIndexHub { hub: string; hubCode: string; amount: number }
const DeliveryPerPriceByHub = defineComponent({
  components: {
    CommonHubSelector,
    PerPriceHorizontalBarChart,
  },
  props: {
    height: {},
    title: {
      type: String,
    },
  },
  setup(props) {
    const filter = reactive({
      hub: null,
      monthRange: {
        from: NOW_START_MONTH,
        to: NOW_END_MONTH,
      },
    });

    const { result, loading } = useQuery(hubPriceIndex, computed(() => ({
      timeframe: filter.monthRange,
    })));

    const chartData = computed(() => {
      const labels: string[] = [];
      const amount: number[] = [];
      (result?.value?.hubPriceIndex || []).forEach((item: PriceIndexHub) => {
        labels.push(item.hub);
        amount.push(item.amount);
      });

      return {
        labels: [...labels],
        datasets: [
          {
            data: [...amount],
            backgroundColor: ['#134889', '#9C28AF', '#FF9700', '#009788', '#CDDC39', '#607D8B', '#9E9E9E', '#03A9F3', '#F44236'],
            barThickness: 80,
          },
          // {
          //   label: 'วันถัดไป',
          //   data: day1,
          //   backgroundColor: deliveryTimeColor.day2,
          //   stack: 'STACK',
          // },
          // {
          //   label: 'ภายใน 3 วัน',
          //   data: day2,
          //   backgroundColor: deliveryTimeColor.day3,
          //   stack: 'STACK',
          // },
          // {
          //   label: 'ภายใน 4-7 วัน',
          //   data: day4,
          //   backgroundColor: deliveryTimeColor.day4,
          //   stack: 'STACK',
          // },
          // {
          //   label: 'มากกว่า 7 วัน',
          //   data: day7,
          //   backgroundColor: deliveryTimeColor.day7,
          //   stack: 'STACK',
          // },
        ],
      };
    });

    return {
      filter,
      chartData,
    };
  },
});

export default DeliveryPerPriceByHub;
